import { render, staticRenderFns } from "./InventoryAdd.vue?vue&type=template&id=fafa3584&scoped=true&"
import script from "./InventoryAdd.vue?vue&type=script&lang=js&"
export * from "./InventoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./InventoryAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InventoryAdd.vue?vue&type=style&index=1&id=fafa3584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa3584",
  null
  
)

export default component.exports